import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const dairyComp: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YY' },
  importType: true,
  instructions: {
    dateInstructionKey: 'select_date_of_milk_production_instruction',
    software: 'DairyComp',
  },
  type: 'dairy-comp',
}
